import React, { useEffect, useState } from 'react';
import 'date-fns';
import {
  Backdrop,
  CardContent,
  Container,
  Card,
  Divider,
  Grid,
  TableCell,
  TableBody,
  TableRow,
  TableSortLabel,
  TableContainer,
  Table,
  TableHead,
  Button,
  Snackbar,
  Breadcrumbs,
  CircularProgress,
  Link,
  Typography,
  FormControlLabel,
  Switch
} from '@material-ui/core';
import {
  getTasksRequest
} from '../../store/actions';
import { makeStyles, ThemeProvider } from '@material-ui/styles';
import { useTranslation } from 'react-i18next';
import Page from 'src/components/Page';
import { getUser } from 'src/utils/Common';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { setTask } from '../../store/actions/taskActions';
import axios from 'src/utils/axios';
import moment from 'moment';
import 'react-confirm-alert/src/react-confirm-alert.css';
import Alert from 'src/components/Alert';
import TimelineIcon from '@material-ui/icons/Timeline';
import { useHistory } from 'react-router';


const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    minWidth: 275,
    paddingTop: theme.spacing(0),
    paddingBottom: theme.spacing(3)
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: '25ch',
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },

  cardscontent: {
    minHeight: 550
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest
    })
  },
  expandOpen: {
    transform: 'rotate(180deg)'
  },
  cardsMax: {
    // maxHeight: 230,
    minHeight: 230
  },
  cardsContentMax: {
    // maxHeight: 180,
    minHeight: 180
  },
  cards: {
    minHeight: 350
    // maxHeight: 500,
  },
  container: {
    maxHeight: 500
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  },
}));

function WatchList ({
  getTasksRequest })
{
  const { t } = useTranslation('Technician_Management');
  const [uyari, setUyari] = React.useState(false);
  const [uyariTip, setUyariTip] = React.useState();
  const classes = useStyles();
  const history = useHistory();
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('');
  const SessionUser = getUser();
  const [responseMessage, setresponseMessage] = useState({
    ErrorCode: '0',
    ErrorDescription: t('success_message1')
  });
  const [loading, setLoading] = useState(false);
  const [offWorkScreenData, setOffWorkScreenData] = useState([]);
  const [initialRows, setinitialRows] = useState('');

  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  }

  const defaultServiceInfo = {
    service: SessionUser.ServiceShopName,
    ServiceShopId: SessionUser.ServiceShopId
  };

  useEffect(() => {
    handleHistory()
  }, [SessionUser.ServiceShopId]);


  const handleHistory = () => {
    setLoading(true);

    axios
      .get(`/GetWatchList/${SessionUser.TechnicianId}`)
      .then(response => {
        const Response = response.data;
        //console.log(Response)
        if (Response.length > -1) {
          setOffWorkScreenData(Response);
          setinitialRows(Response);
        } else {
          setOffWorkScreenData([]);
        }
        setLoading(false);
      })
      .catch(error => {
        setOffWorkScreenData([]);
        setLoading(false);
      });
  };
  const handleChangeSwitch = (WatchListId, Follow) => {

    setLoading(true);
    const data = {
      WatchListId: WatchListId,
      Follow: Follow ? 1 : 0
    };
    const config = {
      headers: { 'Content-Type': 'application/json' }
    };
    var tempScreenData = offWorkScreenData
        tempScreenData.find( x => x.Id == WatchListId).Follow = Follow ? 1 : 0
        setOffWorkScreenData(tempScreenData)
    axios
      .post('/SetWatchList', data, config)
      .then(response => {
        setresponseMessage({
          ErrorCode: responseMessage.ErrorCode,
          ErrorDescription: t('success_message')
        });
        setUyariTip('success');
        setUyari(true);
        setLoading(false);
        handleHistory();
      })
      .catch(error => {
        setOffWorkScreenData([]);
        setLoading(false);
      });
  };

  const SetWorkOrderDetail = (WorkOrderId) => {
    console.log(WorkOrderId)
    getTasksRequest(WorkOrderId);
    history.push(`/WorkOrder/${WorkOrderId}/summary`);
  };

  function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    return stabilizedThis.map(el => el[0]);
  }
  function getComparator(order, orderBy) {
    return order === 'desc'
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }
  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }
  const createSortHandler = property => event => {
    handleRequestSort(event, property);
  };
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };
  let i = 0;

  const dataListCells = [
    {
      id: 'WorkCaseId',
      numeric: true,
      disablePadding: true,
      label: t('lblWorkCaseNo')
    },
    {
      id: 'WorkOrderId',
      numeric: true,
      disablePadding: true,
      label: t('lblWorkOrderNo')
    },
    {
      id: 'ContactName',
      numeric: false,
      disablePadding: true,
      label: t('lblName')
    },
    {
      id: 'ServiceShop',
      numeric: false,
      disablePadding: true,
      label: t('lblServiceShop')
    },
    {
      id: 'Status',
      numeric: false,
      disablePadding: true,
      label: t('lblStatus')
    },
    {
      id: 'CallDate',
      numeric: false,
      disablePadding: true,
      label: t('lblCallDate')
    },
    {
      id: 'FollowDate',
      numeric: false,
      disablePadding: true,
      label: t('lblFollowDate')
    },
    {
      id: 'Note',
      numeric: false,
      disablePadding: true,
      label: t('lblNote')
    }
  ];

  return (
    <Page title="">
      <Container maxWidth="xl" spacing={1}>
        <Breadcrumbs >
          <Link color="inherit">Sirius</Link>
          <Typography color="textPrimary">{t('lblWatchList')}</Typography>
        </Breadcrumbs>
        <Snackbar open={uyari} autoHideDuration={10000} onClose={uyariKapat}>
          <Alert
            onClose={uyariKapat}
            message={responseMessage.ErrorDescription}
            variant={uyariTip}
          />
        </Snackbar>
        <Divider />
        <Card>
          <CardContent>
            <Container maxWidth="xl" spacing={1}>
              < br />
              <TableContainer className={classes.container}>
                <Table stickyHeader aria-label="sticky table" size="small">
                  <TableHead>
                    <TableRow>
                    <TableCell align="left" />
                      {dataListCells.map(headCell => (
                        <TableCell
                          key={headCell.id}
                          align="center"
                          padding={headCell.disablePadding ? 'none' : 'default'}
                          sortDirection={orderBy === headCell.id ? order : false}
                        >
                          <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                          >
                            {headCell.label}
                            {orderBy === headCell.id ? (
                              <span className={classes.visuallyHidden} />
                            ) : null}
                          </TableSortLabel>

                        </TableCell>
                      ))}
                      <TableCell align="left">
                        {t('lblFolowUnfollow')}
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                  {stableSort(offWorkScreenData || [], getComparator(order, orderBy)).map(
                      (row) => (
                      <TableRow key={row.index}>
                        <TableCell align="left">{ }</TableCell>
                        <TableCell align="left">{row.WorkCaseId}</TableCell>
                        <TableCell align="left">
                        <Button
                              variant="contained"
                              color="primary"
                              size="small"
                              fullWidth
                              onClick={event => SetWorkOrderDetail(row.WorkOrderId)}
                            >  {row.WorkOrderId}
                            </Button>
                            </TableCell>
                        <TableCell align="left">{row.ContactName}</TableCell>
                        <TableCell align="left">{row.ServiceShop}</TableCell>
                        <TableCell align="left">{row.Status}</TableCell>
                        <TableCell align="left">{moment(row.CallDate).format('DD-MM-YYYY hh:mm')}</TableCell>
                        <TableCell align="left">{moment(row.FollowDate).format('DD-MM-YYYY hh:mm')}</TableCell>
                        <TableCell align="left">{row.Note}</TableCell>
                        <TableCell align="left">
                          <FormControlLabel
                            control={(
                              <Switch
                                checked={row.Follow === 1 ? true : false}
                                onChange={(e) => handleChangeSwitch(row.Id,
                                  e.target.checked)}
                                name="checked"
                                inputProps={{ 'aria-label': 'secondary checkbox' }}
                              />
                            )}
                            //label={t('Follow-UnFollow')}
                          />
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Container>
          </CardContent>
        </Card>
      </Container>
      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </Page>
  );
}

WatchList.propTypes = {
  className: PropTypes.string
};

export default connect(state => ({ tasks: state.tasks1 }), {
  getTasksRequest,
  setTask
})(WatchList);

